export const TOURNAMENT_LOAD_LEADERBOARD = 'TOURNAMENT_LOAD_LEADERBOARD'
export const TOURNAMENT_LOAD_LEADERBOARD_SUCCESS = 'TOURNAMENT_LOAD_LEADERBOARD_SUCCESS'
export const TOURNAMENT_LOAD_LEADERBOARD_FAILURE = 'TOURNAMENT_LOAD_LEADERBOARD_FAILURE'
